import api from "../axios";

export interface AddDriverCallPayload {
    cabId: string;
    reason: string;
    remarks: string;
    type: string;
    updateBy: string;
}

export const addDriverCall = (data: AddDriverCallPayload) => {
    return api.post('/booking/adddrivercall', data);
};

export const getDriverCalls = (
    fromdate: string,
    todate: string,
    signal?: AbortSignal
) => {
    return api.get(`/booking/getdrivercalls?fromdate=${fromdate}&todate=${todate}`, { signal });
};
